import { memo } from 'react';
import FilterActions from '../../../actions/FiltersActions';
import Analytics from 'arbitrip-common/client/analytics';
import FiltersConstants from '../../../constants/FiltersConstants';
import { useTranslation } from 'react-i18next';

const NoAvailabilityMessage = () => {
	const { t } = useTranslation();
	const handleResetFilterClick = () => {
		Analytics.actions.interactions.filteredDeals(
			FiltersConstants.FILTER_METHOD.DEAL_RESET_FILTER_ALL,
			'unfiltered',
		);
		FilterActions.resetDealsFilters();
	};

	return (
		<div className="no-valid-deals-wrapper">
			<img
				className="empty-state-image"
				src="../../img/recent_searches/recent_searches_empty.svg"
				alt={t('NoResults')}
			></img>
			<div>{t('NoDealsMessage')}</div>
			<div>
				<a href="#!" onClick={handleResetFilterClick}>
					{t('Reset')}
				</a>{' '}
				{t('ResetFilters')}
			</div>
		</div>
	);
};

export default memo(NoAvailabilityMessage);
